import { render, staticRenderFns } from "./ProductCheckout.vue?vue&type=template&id=8a8d5666"
import script from "./ProductCheckout.vue?vue&type=script&lang=ts"
export * from "./ProductCheckout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports